import React from "react";
import style from "./bar.module.css";
import { BarGradientDef } from "./bar-gradient-def";
import { BarShadowFilter } from "./bar-shadow-filter";
import { useBarStyles } from "./useBarStyles";

type BarDisplayProps = {
	id: string;
	x: number;
	y: number;
	width: number;
	height: number;
	isSelected: boolean;
	isHighlighted?: boolean;
	useGradient?: boolean;
	/* progress start point */
	progressX: number;
	progressWidth: number;
	barCornerRadius: number;
	styles: {
		backgroundColor: string;
		backgroundSelectedColor: string;
		progressColor: string;
		progressSelectedColor: string;
		borderColor: string;
		borderWidth: number;
	};
};

export const BarDisplay: React.FC<BarDisplayProps> = ({
	id,
	x,
	y,
	width,
	height,
	barCornerRadius,
	styles,
	isHighlighted = false,
	useGradient = false,
}) => {
	// Don't render if background is transparent/none (invisible task)
	if (
		styles.backgroundColor === "transparent" ||
		styles.backgroundColor === "none"
	) {
		return null;
	}

	const {
		gradientId,
		filterId,
		dimensions,
		fillColor,
		strokeColor,
		strokeWidth,
	} = useBarStyles({
		id,
		x,
		y,
		width,
		height,
		isHighlighted,
		useGradient,
		backgroundColor: styles.backgroundColor,
	});

	return (
		<g>
			<defs>
				{useGradient && (
					<BarGradientDef
						id={gradientId}
						isHighlighted={isHighlighted}
						backgroundColor={styles.backgroundColor}
						backgroundSelectedColor={styles.backgroundSelectedColor}
					/>
				)}
				<BarShadowFilter id={filterId} isHighlighted={isHighlighted} />
			</defs>

			<rect
				data-id={`id-${id}-bar`}
				x={dimensions.x}
				y={dimensions.y}
				width={dimensions.width}
				height={dimensions.height}
				rx={barCornerRadius}
				ry={barCornerRadius}
				fill={fillColor}
				stroke={strokeColor}
				strokeWidth={strokeWidth}
				filter={`url(#${filterId})`}
				className={style.barBackground}
			/>
		</g>
	);
};
